module.exports = __webpack_public_path__ + "static/media/qyj2_hg_10000_04.273aebaf.png";